<div class="dropdown container-fluid">
  <form [formGroup]="filterForm">
    <div
      class="row flex mb-3 global-filter-row"
      [style.--filter-count]="filters.length || 1">
      @for(item of filters; track $index){
      <div
        [ngClass]="getFilterItemClass(item)"
        [ngStyle]="getFilterItemStyle(item)">
        @switch (item?.type) {
        @case ('multiselect-toggle') {
        <multiselect-toggle [data]="item" [optionsMap]="options"></multiselect-toggle>
        }
        @case ('dropdown') {
        <app-global-dropdown [formControlName]="item.key" [options]="options[item.key] || []" [data]="item">
        </app-global-dropdown>
        }
        @case ('slider-range') {
        <app-mat-slider [data]="item">
        </app-mat-slider>
        }
        @case ('button') {
        @if (isOptionButtonFilter(item)) {
        <app-filter-option-buttons
          [formControlName]="item.key"
          [options]="options[item.key] || item.optionsList || []"
          [data]="item">
        </app-filter-option-buttons>
        } @else {
        <app-button [data]="item" [selectedKey]="selectedKey"
          [showResetButton]="showResetButton && hasInsightsButton && item?.key === 'insights'"
          (selectionChange)="onButtonSelectionChange($event)" (resetClick)="resetButton()">
        </app-button>
        }

        }
        @case ('icon') {
        <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;margin-top: 2.2rem;">download</mat-icon>
        }
        @case ('search') {
        <app-search-container [data]="item" (search)="onSearch($event, item.key)">
        </app-search-container>
        }

        @default {}
        }
      </div>
      }

      <div class="col-auto d-flex align-items-center filter-reset-slot" *ngIf="showResetButton">
        <div (click)="resetButton()" class="reset d-flex align-items-center"
          style="cursor: pointer;">

          <svg class="filter-clear-icon me-1" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
            <path d="M3.6 2.5h16.8c.9 0 1.4 1.02.85 1.73l-6.87 8.79v6.02a1 1 0 0 1-1.45.9l-3-1.5a1 1 0 0 1-.55-.9v-4.52L2.75 4.23c-.55-.71-.05-1.73.85-1.73z"/>
            <path d="M17.5 13.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm2.6 6.9-1.1 1.1-1.5-1.5-1.5 1.5-1.1-1.1 1.5-1.5-1.5-1.5 1.1-1.1 1.5 1.5 1.5-1.5 1.1 1.1-1.5 1.5z"/>
          </svg>
          <span></span>
        </div>
      </div>
    </div>
  </form>
</div>
